import React from 'react'
import {Title} from "../constant";
const FormNoData = () => {
    return (
            <>
            <div className="col-md-12">
            <div className="form-wrap">
            <label className="form-label mb-1 fw-medium text-dark">
            {Title.LABEL_NO_DATA}
            </label>
            </div>
            </div>
            </>
           )
}
export default FormNoData;
